import { createSlice } from '@reduxjs/toolkit';

// Local UI state for the Scholars common queue (selected scholars program, server-side
// pagination/sort/filter model). Mirrors manage-applications-slice conventions.
//
// term removed — now resolved server-side (U4-CFG). Do not reintroduce client-side term state.
const initialState = {
    subProgramId: undefined,
    paginationModel: { pageIndex: 0, pageSize: 25 },
    sortModel: [],
    filterModel: [],
    pullInFlight: false,
    lastPullMessage: undefined,
};

const scholarsQueueSlice = createSlice({
    name: 'scholarsQueue',
    initialState,
    reducers: {
        setScholarsSubProgram: (state, { payload }) => { state.subProgramId = payload; state.paginationModel.pageIndex = 0; },
        setScholarsPaginationModel: (state, { payload }) => { state.paginationModel = payload; },
        setScholarsSortModel: (state, { payload }) => { state.sortModel = payload; },
        setScholarsFilterModel: (state, { payload }) => { state.filterModel = payload; },
        setScholarsPullInFlight: (state, { payload }) => { state.pullInFlight = payload; },
        setScholarsLastPullMessage: (state, { payload }) => { state.lastPullMessage = payload; },
    },
});

export const {
    setScholarsSubProgram,
    setScholarsPaginationModel,
    setScholarsSortModel,
    setScholarsFilterModel,
    setScholarsPullInFlight,
    setScholarsLastPullMessage,
} = scholarsQueueSlice.actions;

export const selectScholarsQueue = (state) => state.scholarsQueueSlice;

export default scholarsQueueSlice.reducer;
